// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCGTcpMYKsCsEx6sJRctx37R8Kp0H9sobg",
  authDomain: "react-host1.firebaseapp.com",
  projectId: "react-host1",
  storageBucket: "react-host1.firebasestorage.app",
  messagingSenderId: "419245430859",
  appId: "1:419245430859:web:0df0405713e813acc355ce",
  measurementId: "G-1B7D0G8T21"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider };